module.exports = __webpack_public_path__ + "img/Aston_01L.bf888ee8.gif";